import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pageSize, total, onChange }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (pageSize || 25)));
  const canPrev = page > 1;
  const canNext = page < totalPages;
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total || 0);
  return (
    <div className="flex items-center justify-between gap-3 mt-4 flex-wrap" data-testid="pagination-bar">
      <div className="text-xs text-[#73716D]" data-testid="pagination-summary">
        Showing <span className="font-medium text-[#1A1918]">{start.toLocaleString()}</span>–<span className="font-medium text-[#1A1918]">{end.toLocaleString()}</span> of <span className="font-medium text-[#1A1918]">{(total || 0).toLocaleString()}</span>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={!canPrev} onClick={() => onChange(page - 1)} className="rounded-full h-8" data-testid="page-prev"><ChevronLeft size={14}/></Button>
        <div className="text-xs text-[#73716D]" data-testid="pagination-page">Page {page} / {totalPages}</div>
        <Button variant="outline" size="sm" disabled={!canNext} onClick={() => onChange(page + 1)} className="rounded-full h-8" data-testid="page-next"><ChevronRight size={14}/></Button>
      </div>
    </div>
  );
}
